(function() {
    'use strict';

    angular.module('app')
        .controller('ClientController',function($scope, $location, ClientCompanyListTableService, Windows, ClientService) {

            $scope.init = init;
            $scope.getList = getList;

            init();

            function init() {
                var paginationData = {
                    size: 5,
                    page: 0,
                    sort: 'id'
                };
                getList(paginationData);
            };

            function getList (requestPagination, filters) {
                var requestData = {};
                angular.extend(requestData, requestPagination, filters);
                $scope.companiesListTableData = new ClientCompanyListTableService().tableData;
            }
        });
})();



// WEBPACK FOOTER //
// ./js/controllers/ClientController.js